
import { DeviceUtils } from '@/pixel/index';
import { getEntriesByModelSlug, resolveEntryMutating } from '@/services/ContentfulService.js';

const arLaunchQuery = 'arlaunch';
const arButtonDebugQuery = 'arbutton';

// Device supports AR
export function supportsAR() {
  return DeviceUtils.isiOS() && document.createElement('a').relList.supports('ar');
}

// Device should show a QR code for accessing AR on a separate device
export function supportsQRCode() {
  return !DeviceUtils.isAndroid() && !supportsAR();
}

export function buildUrl(modelUrl, shareUrl, downloadName) {
  if(!modelUrl) {
    throw new Error('No model url provided while opening AR viewer');
  }
  return `${modelUrl}${downloadName ? `?dl=${downloadName}.usdz` : ''}${shareUrl ? `#canonicalWebPageURL=${shareUrl}` : ''}`;
}

export function buildARLaunchUrl(productHashKey, productSlug, router) {
  return productHashKey ? `${import.meta.env.VITE_STOREFRONT_BASE_URL}${router.resolve({ name: 'product', params: { id: productHashKey, slug: productSlug }, query: { [arLaunchQuery]: 'true' } }).href}` : '';
}

export function shouldAutoLaunchAR(route) {
  return route?.query?.[arLaunchQuery] === 'true';
}

export function showDebugARButton(route) {
  return route?.query?.[arButtonDebugQuery] === 'true';
}

// Open the AR viewer. Returns true for success or false if unsupported.
export function openARViewer(url) {
  if(!import.meta.env.SSR && supportsAR() && url) {
    // To force open the AR viewer without customer interaction we must 
    // create an AR link and simulate a click.
    const a = document.createElement('a');
    a.appendChild(document.createElement('img'));
    a.setAttribute('rel', 'ar');
    a.setAttribute('href', url);
    a.click();
    return true;
  }
  return false;
}

export async function loadARModel(productHashKey) {
  const productPage = await getEntriesByModelSlug('productPage', `product-${productHashKey}`, 3, false, 'ignore');
  const model = await resolveEntryMutating(productPage?.fields?.model);
  return model?.fields?.file;
}
